import { localStorage } from 'shared/utils';
import { LocalStorageKey } from 'shared/types';

const getStorageHeight = (key) => {
  let visible;
  let height;

  if (key) {
    let infotexte = localStorage.getItem(LocalStorageKey.INFO_TEXT_VISIBLE);
    infotexte = JSON.parse(infotexte);

    if (infotexte) {
      visible = infotexte[key];
    }
  }

  if (visible !== undefined) height = visible ? undefined : '0px';

  return height;
};

const updateLocalStorage = (key, status) => {
  let infotexte = localStorage.getItem(LocalStorageKey.INFO_TEXT_VISIBLE);

  if (infotexte) infotexte = JSON.parse(infotexte);
  else infotexte = {};

  infotexte[key] = status;
  localStorage.setItem(LocalStorageKey.INFO_TEXT_VISIBLE, JSON.stringify(infotexte));
};

export { getStorageHeight, updateLocalStorage };
